import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0111',
    ecrans: ['00-2'],
    params: [
        'sdvcleintref',
        'stamnetab',
        '?doccleint'
    ]
});
